module.exports = __webpack_public_path__ + "static/img/list2.bdee5a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/JoinUs/img/list2.jpg
// module id = ZSVy
// module chunks = 1